import {onMounted, onUnmounted} from 'vue';


export function useEventListener () {
    const registerEvent = <K extends keyof WindowEventMap>(type: K, listener: (this: Window, ev: WindowEventMap[K]) => void, options?: boolean | AddEventListenerOptions): void => {
        onMounted(() => window.addEventListener(type, listener, options ?? false));
        onUnmounted(() => window.removeEventListener(type, listener, options ?? false));
    };

    const registerPassiveScroll = (listener: (this: Window, ev: WindowEventMap['scroll']) => void) => {
        let passiveSupported = false;

        try {
            const options: AddEventListenerOptions = {
                get passive() {
                    passiveSupported = true;
                    return false;
                },
            };

            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        } catch (err) {
            passiveSupported = false;
        }

        registerEvent('scroll', listener, passiveSupported ? { passive: true } : false);
    };

    return {
        registerEvent,
        registerPassiveScroll,
    };
}